import React from 'react';
import './testimonials.css';
import AVTR1 from '../../assets/avatar1.jpg';
import AVTR2 from '../../assets/avatar2.jpg';
import AVTR3 from '../../assets/avatar3.jpg';
import AVTR4 from '../../assets/avatar4.jpg';

// import Swiper core and required modules
import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
    {
        avatar: AVTR1,
        name: 'Nadiem Makarim',
        review: 'Technology provides speed of information, so that our young generation can increase their capacity in developing resources and competitiveness.'
    },
    {
        avatar: AVTR2,
        name: 'Achmad Zaky',
        review: 'If you don\'t study hard when you are young.You will end up lamenting failure when you are old.'
    },
    {
        avatar: AVTR3,
        name: 'Ryan Gondokusumo',
        review: 'Expand experience by working first, before becoming an entrepreneur. Because this will foster a strong mentality to build a business business.'
    },
    {
        avatar: AVTR4,
        name: 'Alamanda Shantika',
        review: 'The success of successful people is the fruit of a commitment to keep moving forward.'
    },
];

const Testimonials = () => {
    return (
        <section id='testimonials'>
            <h5>Idol in Technology and Business</h5>
            <h2>My Idols</h2>

            <Swiper className="container testimonials__container"
                //install Swiper modules
                modules={[Pagination]}
                spaceBetween={40}
                slidesPerView={1}
                pagination={{ clickable: true }}>
                {
                    data.map(({ avatar, name, review }, index) => {
                        return (
                            <SwiperSlide key={index} className="testimonial">
                                <div className="client__avatar">
                                    <img src={avatar} alt='Avatar One' />
                                </div>
                                <h5 className='client__name'>{name}</h5>
                                <small className='client__review'>"{review}"</small>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </section>
    )
}

export default Testimonials